module.exports = __webpack_public_path__ + "img/minusFilled.ec878d2b.svg";